import React from "../_snowpack/pkg/react.js";
import {createBrowserRouter} from "../_snowpack/pkg/react-router-dom.js";
import HomePage from "./Pages/HomePage/HomePage.js";
import AboutMePage from "./Pages/AboutMe/AboutMePage.js";
import ContactMePage from "./Pages/ContactMe/ContactMePage.js";
import MyProjectsPage from "./Pages/MyProjects/MyProjectsPage.js";
import App from "./App.js";
export const router = createBrowserRouter([
  {
    path: "/",
    element: /* @__PURE__ */ React.createElement(App, null),
    children: [
      {path: "", element: /* @__PURE__ */ React.createElement(HomePage, null)},
      {path: "about-me", element: /* @__PURE__ */ React.createElement(AboutMePage, null)},
      {path: "contact-me", element: /* @__PURE__ */ React.createElement(ContactMePage, null)},
      {path: "my-projects", element: /* @__PURE__ */ React.createElement(MyProjectsPage, null)}
    ]
  }
]);
